﻿import * as React from "react";
import { hashHistory } from "react-router";
import { Fragment, Component } from 'react';
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import LegalStore from "../../../stores/legalStore";
import { ILocalization, IRegisterLocalization } from "../../../models/localization";
import { LookupValue, RegionReferralSource, RegistrationRegion } from "../../../models/lookup";
import { sort } from "../../../utils/data";
import { Auth } from "../../../utils/auth";
import { ScreenMode, LookupType } from "../../../models/enums";
import { IRegistrationError, Registration } from "../../../models/registration";
import { Row, Col, Grid } from "react-flexbox-grid";
import Button from "material-ui/Button";
import TextField from "material-ui/TextField";
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, withMobileDialog } from 'material-ui/Dialog';
import { FormControl, FormHelperText, FormGroup, FormControlLabel } from 'material-ui/Form';
import Input, { InputLabel, InputAdornment } from "material-ui/Input";
import Visibility from "material-ui-icons/Visibility";
import VisibilityOff from "material-ui-icons/VisibilityOff";
import IconButton from "material-ui/IconButton";
import { MenuList, MenuItem, MenuProps } from "material-ui/Menu";
import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";
import Select from "material-ui/Select";
import Tooltip from "material-ui/Tooltip";
import Checkbox from "material-ui/Checkbox";
import Paper from "material-ui/Paper";
import { IMonth } from "../../../models/localization";
import Close from "material-ui-icons/Close";
import * as FontAwesome from "react-fontawesome";
import * as s from "./registration.css";
const dialogStyle: any = { root: { maxWidth: "450px" } };
const styles: any = { formControl: { minWidth: 283 }, MuiIconButton: { color: "#5B6770" }, dateForm: { minWidth: 70 } };
@observer
export default class RegistrationDlg extends React.Component<{ store: SeekerStore }, {}> {
  @observable reg: Registration;
  @observable showPassword: boolean;
  @observable showConfirmationPassword: boolean;
  @observable submitted: boolean;
  @observable showSelectErrMsg: boolean;
  @observable showDateErrorMsg: boolean;
  @observable hasVetStatus: boolean;
  @observable agreesToTerms: boolean;
  @observable isEmailUnique: boolean;
  @observable isPasswordValid: boolean;
  @observable passwordError: string;
  @observable birthday: string;
  @observable regMsg: string;
  @observable month: string;
  @observable year: string;
  @observable day: string;
  constructor(props: any) {
    super(props);
    this.reg = new Registration(this.props.store.localization.language);
    this.showDateErrorMsg = this.showSelectErrMsg = this.submitted = this.showConfirmationPassword = this.showPassword = this.agreesToTerms = false;
    this.birthday = this.regMsg = this.reg.email = this.reg.confirmEmail = this.reg.password = this.reg.confirmPassword = this.reg.firstName = this.reg.lastName = this.reg.zip = this.reg.phone = "";
    this.reg.ethnicity = this.reg.vetStatus = this.reg.militaryStatus = this.reg.gender = this.reg.howHeard = -1;
    this.reg.dob = new Date();
    this.reg.vetStatus > 0 ? this.hasVetStatus = true : this.hasVetStatus = false;
    this.isEmailUnique = this.isPasswordValid = true;
    this.passwordError = "";
    this.day = this.month = this.year = "";
  }
  resetLocalFields = (): void => {
    this.hasVetStatus = this.showSelectErrMsg = this.submitted = this.showConfirmationPassword = this.showPassword = false;
    this.birthday = this.regMsg = "";
    this.reg.ethnicity = this.reg.vetStatus = this.reg.gender = -1;
    this.isEmailUnique = this.isPasswordValid = true;
    this.passwordError = "";
  }
  @action handleSubmit = (): void => {
    this.submitted = true, () => {
      setTimeout(() => this.submitted = false, 5000);
    }
    this.nextStep();
  }
  @action onConfirmation = (err: IRegistrationError): void => {
    const local: ILocalization = this.props.store.localization.fields;
    if (err && err.message) {
      this.regMsg = local.register.msgFail + err.message;
    } else {
      //this.props.store.viewState.showRegister = false;
      this.closeDialog();
    }
  }
  loginCB = (success: boolean, terms: number): void => {
    if (success) {
      this.props.store.profileStore.loadProfile();
    }
  }
  @action closeDialog = (): void => {
    this.props.store.viewState.closeRegistration();
    this.reg.resetAll();
    this.resetLocalFields();
    this.props.store.viewState.setRegisterStep(1);
  }
  componentWillMount() {
    window.scrollTo(0, 0);
    ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
      if (value !== this.reg.password) {
        return false;
      }
      return true;
    });
    ValidatorForm.addValidationRule('isEmailUnique', (value) => {
      return this.isEmailUnique;
    });
    ValidatorForm.addValidationRule('isPasswordValid', (value) => {
      return this.isPasswordValid;
    });
    ValidatorForm.addValidationRule('isEmailMatch', (value) => {
      if (value !== this.reg.email) {
        return false;
      }
      return true;
    });
    ValidatorForm.addValidationRule('isDate', (value) => {
      if (!value.match(/^(19|20)\d\d[\-\/](0[1-9]|1[012])[\-\/](0[1-9]|[12][0-9]|3[01])$/)) {
        return false;
      }
      return true;
    });
  }
  checkDate = (): boolean => {
    const dateString = `${this.day}-${this.month}-${this.year}`;
    if (/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(dateString)) {
      const americanDate = `${this.month}-${this.day}-${this.year}`;
      const year: number = parseInt(this.year);
      let month: number = parseInt(this.month);
      month = month - 1;
      const day: number = parseInt(this.day);
      this.reg.dob = new Date(year, month, day);
      return true;
    }
    return false;
  }
  checkEmail = (): void => {
    Auth.isEmailUnique(this.reg.email, action((unique: boolean): void => {
      this.isEmailUnique = unique;
    }));
  }
  checkPassword = (): void => {
    Auth.isPasswordValid(this.reg.password, action((err: string): void => {
      this.isPasswordValid = err.length === 0;
      this.passwordError = err;
    }));
  }
  prevStep = (): void => {
    let step = this.props.store.viewState.registerStep;
    if (step > 1) {
      step--;
    }
    this.props.store.viewState.setRegisterStep(step);
  }
  nextStep = (): void => {
    const local: IRegisterLocalization = this.props.store.localization.fields.register;
    let step = this.props.store.viewState.registerStep;
    if (step === 1 && !this.isEmailUnique) {
      return;
    }
    if (step == 3) {
      let valid: boolean = true;
      valid = valid && this.reg.vetStatus !== -1 && this.checkDate();
      valid = valid && (!local.showHowHeard || (local.showHowHeard && this.reg.howHeard !== -1)) && this.checkDate();
      valid = valid && (!local.showRegionalSrc || (local.showRegionalSrc && this.reg.region !== "" && this.reg.regionSrc !== "")) && this.checkDate();
      if (valid) {
        this.showSelectErrMsg = false;
        this.showDateErrorMsg = false;
      }
      else {
        if (!this.checkDate()) {
          this.showDateErrorMsg = true;
          this.showSelectErrMsg = false;
        } else {
          this.showSelectErrMsg = true;
          this.showDateErrorMsg = false;
        }
        return;
      }
    }
    if (step == 4) {
      if (this.reg.ethnicity != -1 && this.reg.gender != -1 && this.agreesToTerms) {
        this.showSelectErrMsg = false;
      } else {
        this.showSelectErrMsg = true;
        return;
      }
    }
    if (step < 5) {
      step++;
    }
    this.props.store.viewState.setRegisterStep(step);
    if (step == 5) {
      Auth.register(this.reg, this.onConfirmation, this.loginCB);
    }
  }
  handleTooltipClose = () => {
    this.setState({ open: false });
  };
  handleTooltipOpen = () => {
    this.setState({ open: true });
  };
  @action togglePassword = (): void => {
    this.showPassword = !this.showPassword;
  }
  @action toggleConfirmationPassword = (): void => {
    this.showConfirmationPassword = !this.showConfirmationPassword;
  }
  @action handleInputChange = (event: { target: HTMLInputElement; }): void => {
    this.reg[event.target.name] = event.target.value;
    if (event.target.name === "email") {
      this.reg.email = event.target.value.trim();
    }
  }
  @action handleDateChange = (event: { target: HTMLInputElement; }): void => {
    this.birthday = event.target.value;
    this.reg.dob = new Date(event.target.value);
  }
  @action handleSelectionChange = (event: { target: any; }): void => {
    const key: string = event.target.name || event.target.id;
    if (key === "howHeard") {
      this.reg.howHeard = Number(event.target.value);
    } else if (key === "vetStatus") {
      this.reg.vetStatus = Number(event.target.value);
    } else if (key === "ethnicity") {
      this.reg.ethnicity = Number(event.target.value);
    } else if (key === "gender") {
      this.reg.gender = Number(event.target.value);
    } else if (key === "day") {
      this.day = event.target.value;
    } else if (key === "month") {
      this.month = event.target.value;
    } else if (key === "year") {
      this.year = event.target.value;
    }
    else {
      this.reg[key] = event.target.value;
    }
  }
  @action setAgrees = (agrees: boolean): void => {
    this.agreesToTerms = agrees;
  }
  private getMonths(): JSX.Element[] {
    const months: JSX.Element[] = [];
    let i: number = 0;
    this.props.store.localization.fields.months.map((m: IMonth, i): void => {
      if (i < 10) {
        months.push(<MenuItem key={i} value={`0${m.ndx}`}>{m.mon}</MenuItem>);
      } else {
        months.push(<MenuItem key={i} value={`${m.ndx}`}>{m.mon}</MenuItem>);
      }
    });
    return months;
  }
  private getYears(): JSX.Element[] {
    const yrs: JSX.Element[] = [];
    let start: number = 0;
    let end: number = 100;
    start = new Date().getFullYear();
    end = start - 80;
    for (let i: number = start; i >= end; --i) {
      yrs.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
    }
    return yrs;
  }
  private getDays(): JSX.Element[] {
    const days: JSX.Element[] = [];
    for (let i: number = 1; i <= 31; i++) {
      if (i < 10) {
        days.push(<MenuItem key={i} value={"0" + i}>{`0${i}`}</MenuItem>);
      } else {
        days.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
      }
    }
    return days;
  }
  renderStep1Content(local: ILocalization): JSX.Element {
    return (
      <Row>
        <Col xs={12} smOffset={2} sm={8} >
          <div>
            <FormControl style={styles.formControl}>
              <TextValidator
                label={local.register.enterEmail}
                name="email"
                id="email"
                inputProps={{
                  autoCapitalize: "none",
                }}
                validators={['required', 'isEmail', 'isEmailUnique']}
                errorMessages={[local.validation.requiredField, local.validation.requiredField, local.validation.emailExists]}
                value={this.reg.email}
                onChange={this.handleInputChange}
                onBlur={this.checkEmail} />
              <div>
                <p className={s.createEmailQuestion}>{local.login.emailQuestion}</p>
                <p className={s.createEmailLink} onClick={() => this.props.store.viewState.showLink("https://myaccount.google.com/")} ><FontAwesome name="envelope" className="fa-1x" ></FontAwesome> {local.login.emailClickThrough}</p>
              </div>
              <br />
              <TextValidator
                label={local.register.confirmEmail}
                name="confirmEmail"
                id="confirmEmail"
                inputProps={{
                  autoCapitalize: "none",
                }}
                validators={['required', 'isEmail', 'isEmailMatch']}
                errorMessages={[local.validation.requiredField, local.validation.invalidEmail, local.validation.emailMismatch]}
                value={this.reg.confirmEmail}
                onChange={this.handleInputChange} />
              <br />
              <br />
              <TextValidator
                label={local.register.enterPassword}
                name="password"
                id="password"
                autoComplete="off"
                type={this.showPassword ? "text" : "password"}
                validators={['required', 'isPasswordValid']}
                errorMessages={[local.validation.requiredField, this.passwordError]}
                value={this.reg.password}
                onChange={this.handleInputChange}
                onBlur={this.checkPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton style={styles.MuiIconButton} onClick={this.togglePassword} onMouseDown={() => (e) => event.preventDefault()}>
                        {this.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>)
                }} />
              <br /> <br />
              <TextValidator
                label={local.register.confirmPwd}
                name="confirmPassword"
                id="confirmPassword"
                autoComplete="off"
                type={this.showConfirmationPassword ? "text" : "password"}
                validators={['required', 'isPasswordMatch']}
                errorMessages={[local.validation.requiredField, local.validation.passwordMismatch]}
                value={this.reg.confirmPassword}
                onChange={this.handleInputChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton style={styles.MuiIconButton} onClick={this.toggleConfirmationPassword} onMouseDown={() => (e) => event.preventDefault()}>
                        {this.showConfirmationPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>)
                }} />
            </FormControl>
          </div>
        </Col>
      </Row>
    );
  }
  renderStep2Content(local: ILocalization): JSX.Element {
    return (
      <Row>
        <Col xs={12} smOffset={2} sm={8} >
          <FormControl style={styles.formControl}>
            <TextValidator
              autoFocus
              label={local.register.firstName}
              name="firstName"
              id="firstName"
              validators={['required']}
              errorMessages={[local.validation.requiredField]}
              value={this.reg.firstName}
              onChange={this.handleInputChange} />
            <br /><br />
            <TextValidator
              label={local.register.lastName}
              name="lastName"
              id="lastName"
              validators={['required']}
              errorMessages={[local.validation.requiredField]}
              value={this.reg.lastName}
              onChange={this.handleInputChange} />
            <br /><br />
            <Tooltip
              id="tooltip-zip"
              title={local.register.whyZip}
              enterDelay={300}
              leaveDelay={300}
              onOpen={this.handleTooltipOpen}
              placement="bottom">
              <TextValidator
                label={local.register.zip}
                name="zip"
                id="zip"
                validators={['required', 'matchRegexp:^[0-9]{5}([-][0-9]{4})?$']}
                errorMessages={[local.validation.requiredField, local.validation.zipcodeInvalid]}
                value={this.reg.zip}
                onChange={this.handleInputChange} />
            </Tooltip>
            <br /><br />
            <TextValidator
              label={local.register.phone}
              name="phone"
              id="phone"
              validators={['required', 'matchRegexp:^[0-9]{3}([-]?)([0-9]{3})([-]?)[0-9]{4}$']}
              errorMessages={[local.validation.requiredField, local.validation.phoneNumberInvalid]}
              value={this.reg.phone}
              onChange={this.handleInputChange} />
          </FormControl>
        </Col>
      </Row>
    );
  }
  getRegionSources(): JSX.Element[] {
    let items: JSX.Element[] = [];
    const region: RegistrationRegion = this.props.store.localization.regions.find((r: RegistrationRegion): boolean => {
      return r.idHash === this.reg.region;
    });
    if (region) {
      region.sources.map((rrs: RegionReferralSource, i: number): void => {
        items.push(<MenuItem key={`regionSrc-${i}`} value={rrs.idHash}>{rrs.name}</MenuItem>);
      });
    }
    return items;
  }
  renderStep3Content(local: ILocalization): JSX.Element {
    const wordWrap: any = { whiteSpace: "pre-wrap" };
    return (
      <Row>
        <Col xs={12} smOffset={2} sm={8}  >
          <br />
          <Row>
            <Col xs={12}>
              <Tooltip
                id="tooltip-controlled"
                title={local.register.whyDOB}
                enterDelay={300}
                leaveDelay={300}
                onOpen={this.handleTooltipOpen}
                placement="bottom">
                <p className={s.birthday}>{local.register.birthday}(?)</p>
              </Tooltip>
            </Col>
            <Col xs={4}>          
                <FormControl style={styles.dateForm} >
                  <InputLabel htmlFor="month">{local.register.month}</InputLabel>
                  <Select input={<Input id="month" />} name="month" value={this.month} onChange={this.handleSelectionChange}>
                    {this.getMonths()}
                  </Select>
                </FormControl>

            </Col>
            <Col xs={4}>
              <FormControl style={styles.dateForm}>
                <InputLabel htmlFor="day">{local.register.day}</InputLabel>
                <Select input={<Input id="day" />} name="day" value={this.day} onChange={this.handleSelectionChange}>
                  {this.getDays()}
                </Select>
              </FormControl>            
            </Col>
            <Col xs={4}>
              <FormControl style={styles.dateForm} >
                <InputLabel htmlFor="year">{local.register.year}</InputLabel>
                <Select input={<Input id="year" />} name="year" value={this.year} onChange={this.handleSelectionChange}>
                  {this.getYears()}
                </Select>
              </FormControl>
            </Col>
          </Row>
          <p className={s.errorText}>{this.showDateErrorMsg ? local.validation.dateErrMsg : null}</p>
          <br /><br />
          <FormControl style={styles.formControl}>
            <InputLabel htmlFor="vetStatus">{local.register.veteran}</InputLabel>
            <Select
              fullWidth
              name="vetStatus"
              value={this.reg.vetStatus}
              onChange={this.handleSelectionChange}
              inputProps={{
                id: 'vetStatus',
                name: 'vetStatus',
              }}>
              {this.props.store.localization.getLookup(LookupType.VetStatus).map((d, i) => {
                return (<MenuItem key={"vetSatus-" + i} value={d.order} style={wordWrap} >{d.value}</MenuItem>)
              })}
            </Select>
          </FormControl>
          <br /><br />
          {local.register.showHowHeard && <div>
            <FormControl style={styles.formControl}>
              <InputLabel htmlFor="howHeard">{local.register.howHeard}</InputLabel>
              <Select
                fullWidth
                name="howHeard"
                value={this.reg.howHeard}
                onChange={this.handleSelectionChange}
                inputProps={{
                  id: 'howHeard',
                  name: 'howHeard',
                }}>
                {sort(this.props.store.localization.getLookup(LookupType.HowHeard), "value").map((d: LookupValue, i: number) => {
                  return (<MenuItem style={wordWrap} key={"howHeard-" + i} value={d.order}>{d.value}</MenuItem>)
                })}
              </Select>
            </FormControl>
            <br /><br />
            {this.reg.howHeard === 902 && <div>
              <TextField label={local.register.howHeardOther} value={this.reg.howHeardOther} onChange={this.handleInputChange} name="howHeardOther" id="howHeardOther" /><br /><br />
            </div>}
          </div>}
          {local.register.showRegionalSrc && <div>
            <FormControl style={styles.formControl}>
              <InputLabel htmlFor="region">{local.register.region}</InputLabel>
              <Select fullWidth name="region" value={this.reg.region} inputProps={{ id: "region", name: "region" }} onChange={this.handleSelectionChange}>
                {this.props.store.localization.regions.map((rr: RegistrationRegion, i: number) => {
                  return (<MenuItem key={`region-${i}`} value={rr.idHash} style={wordWrap}>{rr.name}</MenuItem>)
                })}
              </Select>
            </FormControl>
            <br /><br />
            <FormControl style={styles.formControl}>
              <InputLabel htmlFor="regionSrc">{local.register.referralSource}</InputLabel>
              <Select fullWidth name="regionSrc" value={this.reg.regionSrc} inputProps={{ id: "regionSrc", name: "regionSrc" }} onChange={this.handleSelectionChange} style={wordWrap}>
                {this.getRegionSources()}
              </Select>
            </FormControl>
          </div>}
          <p className={s.errorText}>{this.showSelectErrMsg ? local.register.selectErr : null}</p>
        </Col>
      </Row>
    );
  }
  renderStep4Content(local: ILocalization): JSX.Element {
    const ls: LegalStore = this.props.store.legal;
    const wordWrap: any = { whiteSpace: "pre-wrap" };
    return (
      <Row>
        <Col xs={12} smOffset={2} sm={10}  >
          <FormControl style={styles.formControl}>
            <InputLabel htmlFor="ethnicity">{local.register.ethnicityQuestion}</InputLabel>
            <Select
              fullWidth
              name="ethnicity"
              value={this.reg.ethnicity}
              onChange={this.handleSelectionChange}
              inputProps={{
                id: 'ethnicity',
                name: 'ethnicity',
              }}>
              {this.props.store.localization.getLookup(LookupType.Ethnicity).map((d: LookupValue, i: number) => {
                return (<MenuItem key={"ethnicity-" + i} value={d.order} style={wordWrap}>{d.value}</MenuItem>)
              })}
            </Select>
          </FormControl>
          <br /><br /><br /><br />
          <FormControl style={styles.formControl}>
            <InputLabel htmlFor="gender">{local.register.genderQuestion}</InputLabel>
            <Select
              fullWidth
              name="gender"
              value={this.reg.gender}
              onChange={this.handleSelectionChange}
              inputProps={{
                id: 'gender',
                name: 'gender',
              }}>
              {this.props.store.localization.getLookup(LookupType.Gender).map((d: LookupValue, i: number) => {
                return (<MenuItem key={"gender-" + i} value={d.order} style={wordWrap}>{d.value}</MenuItem>)
              })}
            </Select>
          </FormControl>
          <br /><br /><br /><br />
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  style={styles.MuiIconButton}
                  checked={this.agreesToTerms}
                  color="secondary"
                  onChange={(e, chk) => this.setAgrees(chk)}
                  value="checked" />}
              label={<div>I agree to the site's <a className={s.tandc} onClick={() => ls.showTermsAndConditions()}>{local.nav.tandc}</a> and <a className={s.tandc} onClick={() => ls.showPrivacyStatement()}>{local.nav.privacy}</a></div>} />          
          </FormGroup>
          <br />
          <p className={s.errorText}>{this.showSelectErrMsg ? local.register.selectErr : null}</p>
        </Col>
      </Row>
    );
  }
  renderStep5Content(local: ILocalization): JSX.Element {
    return (
      <Row>
        <Col xs={12} smOffset={2} sm={8}  >
          <h3>{local.register.thankyou}</h3><br />
          {this.regMsg}
        </Col>
      </Row>
    );
  }
  renderStep = (): any => {
    const local: ILocalization = this.props.store.localization.fields;
    const agrees: boolean = this.props.store.legal.acceptTerms === 2;
    switch (this.props.store.viewState.registerStep) {
      case 1:
        return this.renderStep1Content(local);
      case 2:
        return this.renderStep2Content(local);
      case 3:
        return this.renderStep3Content(local);
      case 4:
        return this.renderStep4Content(local);
      case 5:
        return this.renderStep5Content(local);
      default:
        return null;
    }
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    let step = this.props.store.viewState.registerStep;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const imgUrl: string = local.register.regLogo || "images/ss-logo-lg.png";
    const color: string = local.login.customColor || "#0072CE";
    const stylesBtn: any = ({
      root: {
        backgroundColor: "white",
        color: color,
      },
      MuiIconButton: {
        color: "#5B6770",
        margin: "8px",
      },
      icon: {
        height: "36px",
        width: "36px",
      }
    });
    const actions: any = {
      root: {
        justifyContent: "space-around",
        marginBottom: "50px",
      },
    };
    return <div>
      <Dialog
        open={this.props.store.viewState.showRegister}
        onClose={() => this.closeDialog()}
        aria-labelledby="responsive-dialog-title"
        onBackdropClick={() => this.closeDialog()}
        fullScreen={mode === ScreenMode.Mobile} >
        <ValidatorForm
          ref="form"
          instantValidate={false}
          onSubmit={this.handleSubmit}>
          <DialogContent style={dialogStyle.root} >
            <Grid className={s.gridContainer}>
              <Row middle="xs">
                <Col xs={10} sm={6} >
                  <div><img src={imgUrl} alt={local.register.regLogoAlt} width="90%" height="auto" onClick={() => hashHistory.push("/home")} /></div>
                </Col>
                <Col xs={2} smOffset={4} sm={2} >
                  <IconButton style={stylesBtn.MuiIconButton} aria-label="close" onClick={() => this.closeDialog()}><Close style={stylesBtn.icon} /></IconButton>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={12} >
                  <h3 className={s.heading}>{local.register.title}</h3>
                </Col>
              </Row>
              <br />
              {this.renderStep()}
              <br />
            </Grid>
          </DialogContent>
          <DialogActions style={actions.root}>
            <Button
              style={stylesBtn.root}
              onClick={step < 2 || step > 4 ? () => this.closeDialog() : () => this.prevStep()}
              color="secondary">
              {(step < 2 || step > 4 ? local.cancel : local.register.back)}
            </Button>
            <Paper square elevation={0}>
              <p>{step < 5 ? `${local.register.step} ${step} ${local.of} 4` : null}</p>
            </Paper>
            <Button
              style={stylesBtn.root}
              type="submit"
              disabled={step === 5 && !this.agreesToTerms}
              onClick={step === 5 ? () => this.closeDialog() : null}
              color="secondary" autoFocus>
              {step < 4 ? local.register.next : step === 5 ? local.register.okay : local.register.finish}
            </Button>
          </DialogActions>
        </ValidatorForm>
      </Dialog>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/dialogs/registration/index.tsx